import React from 'react';
import { SecondaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { LogoCAIcon } from '@components/icons/LogoCA.icon';
import { Text } from '@components/Text/Text.component';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { Breakpoint, useBreakpoint } from '@styles/breakpoints';
import { urlEnum } from '@utils/url';
import style from './CASection.module.scss';

const CASection = () => {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint < Breakpoint.s;

  return (
    <section className={style['ca-section']}>
      <div>
        <div>
          <LogoCAIcon width={isMobile ? 53 : 84} />
        </div>

        <div className="text-container">
          <Text className="plc-mb-s" flavour="light" i18nKey="landing.ca-title" variant={isMobile ? 'h4' : 'h3'} />
          <Text flavour="light" i18nKey="landing.ca-content" variant="p" />
          <Text className="plc-my-m" flavour="light" i18nKey="landing.ca-sub-title" variant="p" />
          <PlcAnchor linkProps={{ as: urlEnum.signUp, href: `${urlEnum.signUp}?profil=pro` }}>
            <SecondaryButton
              className="dark-midnight-green"
              isSmall
              textProps={{ i18nKey: 'landing.ca-button', variant: 'new-bold-p' }}
            />
          </PlcAnchor>
          <Text
            className="plc-mt-m"
            flavour="light"
            i18nKey="landing.ca-mention"
            style={{ fontStyle: 'italic' }}
            variant="tiny"
          />
        </div>
      </div>
    </section>
  );
};

export { CASection };
